import React from 'react'
import PropTypes from 'prop-types'

import { Typography } from '@material-ui/core'

import { formatPrice } from 'common/utils/format'

import { AsteriskBox, Price, PriceRow, Prices, Root, SizeText } from './StackedMosaicPrices.style'

const StackedMosaicPrices = ({ large, small, asterisks }) => (
  <Root>
    <Prices>
      {[large, small].map((product) => (
        <React.Fragment key={product.name}>
          <PriceRow>
            <Price>{formatPrice(product.non_bundle_price, 'short')}</Price>
            <SizeText>
              {product.name} {product.width}"x{product.height}"
            </SizeText>
          </PriceRow>
          <Typography>{formatPrice(product.price, 'short')} bundled with a Kids Art Book</Typography>
        </React.Fragment>
      ))}
    </Prices>
    {!!asterisks.length && (
      <AsteriskBox>
        {asterisks.map((asterisk, index) => (
          <Typography variant='caption' key={index}>
            {asterisk}
          </Typography>
        ))}
      </AsteriskBox>
    )}
  </Root>
)

const productShape = PropTypes.shape({
  non_bundle_price: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
})

StackedMosaicPrices.propTypes = {
  large: productShape.isRequired,
  small: productShape.isRequired,
  asterisks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default StackedMosaicPrices
